// Carry Roll CsvImport — CSV import from launch monitors (8.8).

import { useState } from 'react';
import { Select } from 'calc-controls';
import { useStore } from '../../store';
import { parseCsv, sampleCsv, type MonitorFormat } from '../../import/csvImport';

const FORMATS: { value: MonitorFormat; label: string }[] = [
  { value: 'garmin', label: 'Garmin' },
  { value: 'skytrak', label: 'SkyTrak' },
  { value: 'mevo', label: 'Mevo+' },
  { value: 'foresight', label: 'Foresight' },
  { value: 'rapsodo', label: 'Rapsodo' },
];

export function CsvImport() {
  const importCsv = useStore((s) => s.importCsv);
  const [format, setFormat] = useState<MonitorFormat>('garmin');
  const [text, setText] = useState('');
  const [error, setError] = useState('');

  const handleImport = () => {
    const csv = text || sampleCsv(format);
    const result = parseCsv(csv, format);
    if (result.shots.length === 0) {
      setError('Unrecognized CSV format. Select your monitor or check the file.');
      return;
    }
    setError('');
    importCsv(result.shots, format);
  };

  return (
    <div data-testid="csv-import">
      <h3 className="subsection-title">
        CSV import
      </h3>
      <div className="block mb-2">
        <span className="field-label">Monitor format</span>
        <Select
          inline
          label="Monitor format"
          value={format}
          onChange={(v) => setFormat(v as MonitorFormat)}
          options={FORMATS}
        />
      </div>
      <textarea
        className="field-input mb-2"
        rows={3}
        placeholder="Paste CSV data…"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <button type="button" className="btn btn-primary" onClick={handleImport}>
        Import
      </button>
      {error && (
        <p className="text-sm mt-2" style={{ color: 'var(--color-danger)' }} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
